import React, { useState } from 'react'
import { X, Send, CheckCircle2, Upload } from 'lucide-react'
import { useQuoteModal } from '../../context/QuoteContext'
import { Button } from '../Button/Button'

export const QuoteModal = () => {
	const { isOpen, closeQuoteModal } = useQuoteModal()
	const [submitted, setSubmitted] = useState(false)

	if (!isOpen) return null

	const handleSubmit = (e) => {
		e.preventDefault()
		setSubmitted(true)
	}

	const handleClose = () => {
		setSubmitted(false)
		closeQuoteModal()
	}

	return (
		<div className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/70 backdrop-blur-sm animate-in fade-in duration-200'>
			{/* Modal Card */}
			<div className='relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl border border-brand-border overflow-hidden max-h-[90vh] flex flex-col'>
				{/* Header (No Chip, Matched Styling) */}
				<div className='flex items-center justify-between px-6 py-4 bg-brand-dark text-white border-b border-slate-800'>
					<div>
						<h2 className='font-heading text-xl font-bold'>Request a Quote</h2>
					</div>
					<button
						onClick={handleClose}
						className='p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-full transition-colors'>
						<X className='w-5 h-5' />
					</button>
				</div>

				{/* Scrollable Form Body */}
				<div className='p-6 sm:p-8 overflow-y-auto'>
					{submitted ? (
						<div className='py-10 text-center bg-brand-blue/5 rounded-xl border border-brand-blue/20 p-6'>
							<CheckCircle2 className='w-12 h-12 text-brand-blue mx-auto mb-3' />
							<h3 className='font-heading text-xl font-bold text-brand-dark'>
								Quote Request Submitted
							</h3>
							<p className='text-slate-600 text-sm mt-1 max-w-md mx-auto'>
								Thank you for your request. Our sales team will review your
								project details and respond shortly.
							</p>
							<Button size='md' className='mt-6' onClick={handleClose}>
								Return to Site
							</Button>
						</div>
					) : (
						<form onSubmit={handleSubmit} className='space-y-5'>
							{/* Contact Name & Company Name */}
							<div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
								<div>
									<label className='block text-xs font-bold uppercase tracking-wider text-slate-700 mb-1.5'>
										Contact Name *
									</label>
									<input
										type='text'
										required
										placeholder='e.g. Sarah Jenkins'
										className='w-full px-4 py-2.5 rounded-xl border border-brand-border text-sm focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue text-slate-900 transition-all'
									/>
								</div>
								<div>
									<label className='block text-xs font-bold uppercase tracking-wider text-slate-700 mb-1.5'>
										Company Name *
									</label>
									<input
										type='text'
										required
										placeholder='e.g. Apex Civils'
										className='w-full px-4 py-2.5 rounded-xl border border-brand-border text-sm focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue text-slate-900 transition-all'
									/>
								</div>
							</div>

							{/* Email & Phone */}
							<div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
								<div>
									<label className='block text-xs font-bold uppercase tracking-wider text-slate-700 mb-1.5'>
										Email Address *
									</label>
									<input
										type='email'
										required
										placeholder='sarah@apexcivils.co.za'
										className='w-full px-4 py-2.5 rounded-xl border border-brand-border text-sm focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue text-slate-900 transition-all'
									/>
								</div>
								<div>
									<label className='block text-xs font-bold uppercase tracking-wider text-slate-700 mb-1.5'>
										Phone Number *
									</label>
									<input
										type='tel'
										required
										placeholder='+27 82 000 0000'
										className='w-full px-4 py-2.5 rounded-xl border border-brand-border text-sm focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue text-slate-900 transition-all'
									/>
								</div>
							</div>

							{/* Specification Notes / Details */}
							<div>
								<label className='block text-xs font-bold uppercase tracking-wider text-slate-700 mb-1.5'>
									Specification Notes / Required Quantities
								</label>
								<textarea
									rows={4}
									placeholder='Detail your required pipe sizes, quantities, pressure ratings, or site delivery location...'
									className='w-full px-4 py-2.5 rounded-xl border border-brand-border text-sm focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue text-slate-900 transition-all'></textarea>
							</div>

							{/* Optional BOQ File Upload Box */}
							<div className='p-4 border-2 border-dashed border-brand-border rounded-xl bg-slate-50 flex items-center justify-between'>
								<div className='flex items-center gap-3'>
									<Upload className='w-5 h-5 text-slate-400' />
									<div>
										<p className='text-xs font-semibold text-slate-800'>
											Attach Document (Optional)
										</p>
										<p className='text-[11px] text-slate-500'>
											PDF, XLSX, or DOCX up to 10MB
										</p>
									</div>
								</div>
								<input type='file' className='hidden' id='boq-upload' />
								<label
									htmlFor='boq-upload'
									className='px-3 py-1.5 text-xs font-bold bg-white border border-brand-border hover:bg-slate-100 rounded-lg cursor-pointer text-slate-700 transition-colors'>
									Browse
								</label>
							</div>

							{/* Actions */}
							<div className='pt-2 flex items-center justify-end gap-3'>
								<button
									type='button'
									onClick={handleClose}
									className='px-5 py-2.5 text-xs font-bold text-slate-600 hover:bg-slate-100 rounded-full transition-colors'>
									Cancel
								</button>
								<Button
									type='submit'
									size='md'
									className='flex items-center gap-2'>
									<Send className='w-4 h-4' />
									Submit Quote Request
								</Button>
							</div>
						</form>
					)}
				</div>
			</div>
		</div>
	)
}
